import {EMAIL_ADDRESS_REGEX} from '../../../../../constants/constants';

export const validateProjectName = (name: string): boolean => {
  return /^[a-zA-Z0-9 ]*$/.test(name);
};

export const validateClientId = (input: string): boolean => {
  return /^[a-zA-Z0-9-_]*$/.test(input);
};

export const validateAdditionalContactEmail = (
  input: string,
  isBlur?: boolean
): boolean => {
  const emails = input
    .split(',')
    .map((e) => e.trim())
    .filter((e) => e.length > 0);

  return isBlur
    ? !emails.some((email) => !EMAIL_ADDRESS_REGEX.test(email))
    : !emails.some(
        (email) => email.length >= 3 && !EMAIL_ADDRESS_REGEX.test(email)
      );
};
